import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.indeterminate = this.isIndeterminate
  }

  get isIndeterminate() {
    return this.element.dataset.checkboxIndeterminate === "true"
  }
}
